import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Group, Modal, Text } from "@mantine/core";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
export default function ChildDeleteModal(_a) {
    var child = _a.child, show = _a.show, onClose = _a.onClose;
    var _b = useState(false), deleting = _b[0], setDeleting = _b[1];
    var params = useParams();
    var navigate = useNavigate();
    var doRemoveChild = function () {
        setDeleting(true);
        fetch('/api/child/' + encodeURIComponent(params.id) + '/remove', {
            method: 'POST'
        })
            .then(function (res) {
            if (res.status === 401) {
                navigate('/login');
                return;
            }
            if (res.status === 404) {
                navigate('/404');
                return;
            }
            navigate('/children');
        });
    };
    return _jsxs(Modal, { opened: show, onClose: onClose, title: "Remove Child", centered: true, size: "sm", styles: {
            title: { fontWeight: 700 }
        }, closeButtonProps: { 'aria-label': 'Close modal' }, children: [_jsx(Text, { size: "sm", c: "dimmed", children: "Are you sure you want to remove this child? This action cannot be undone." }), _jsxs(Group, { justify: "flex-end", mt: "xl", gap: "sm", children: [_jsx(Button, { variant: "filled", color: "red", onClick: doRemoveChild, disabled: deleting, children: "Remove" }), _jsx(Button, { variant: "default", onClick: onClose, children: "Cancel" })] })] });
}
